import { Injectable } from '@angular/core';

declare var window;

@Injectable()
export class GlobalvariablesProvider {
  public idleTimeout = 600; // 10 minute in seconds
  public ajaxTimeout = 120000; // milliseconds
  public reloadSettingsMilliseconds = 120000;
  public mapButton: boolean = false;
  public helpButton: boolean = true;
  public closeButton: boolean = false;
  public cameraButton: boolean = false;

  private baseUrl: string;
  private imageURL: string;
  public isDevice: boolean;
  public customerName: string;
  public authorizationCode: string;
  public savingGoal: any = {
    title: '',
    amount: '',
    target_date: "2017-06-28",
    image: null,
    base_64_image: '',
    account_number: null,
  };
  public customerId: any;
  public authorization;
  public color = "#005caa"
  constructor(
  ) {
    this.setBaseUrl("https://myaccount.steponefinance.co.uk");
  }

  setBaseUrl(value) {
    this.baseUrl = value;
    this.imageURL = value + "/temp/";
  }

  setBaseUrlAuth(value) {
    this.baseUrl = value;
    this.imageURL = value + "/temp/";
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  getImageURL() {
    return this.imageURL;
  }
}


// WEBPACK FOOTER //
// ./src/providers/globalvariables/globalvariables.ts